import { Skeleton } from "@nexus/ui"

const AVATAR_SKELETON_COUNT = 5
const STAGE_CARD_SKELETON_COUNT = 2

/**
 * Loading skeleton mirroring `PersonasOnboardingFlow`'s intro shell (B11) — shown
 * while we don't yet know whether the tenant is heading into onboarding, so the
 * swap from skeleton to real content doesn't reflow the page.
 */
export function PersonasOnboardingLoadingState() {
  return (
    <div className="flex flex-col gap-4 p-4" data-testid="personas-onboarding-loading">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-6 w-40 rounded-md" />
        <Skeleton className="h-4 w-72 rounded-md" />
      </div>

      <section className="mx-auto flex w-full max-w-3xl flex-col items-center px-2 py-6">
        <div className="flex w-full flex-col items-center gap-7 rounded-xl border border-border bg-card px-6 py-10 text-center sm:px-10 sm:py-12">
          <div className="flex -space-x-2.5">
            {Array.from({ length: AVATAR_SKELETON_COUNT }).map((_, i) => (
              <Skeleton key={i} className="size-11 rounded-full border-2 border-card sm:size-12" />
            ))}
          </div>

          <div className="flex w-full max-w-xl flex-col items-center gap-3">
            <Skeleton className="h-7 w-72 rounded-md" />
            <Skeleton className="h-4 w-full rounded-md" />
            <Skeleton className="h-4 w-5/6 rounded-md" />
          </div>

          <div className="grid w-full max-w-2xl gap-3 sm:grid-cols-2 sm:gap-4">
            {Array.from({ length: STAGE_CARD_SKELETON_COUNT }).map((_, i) => (
              <div
                key={i}
                className="flex flex-col gap-2 rounded-lg border border-border bg-background px-4 py-4 text-left sm:px-5 sm:py-5"
              >
                <Skeleton className="h-3 w-16 rounded-md" />
                <Skeleton className="h-4 w-32 rounded-md" />
                <Skeleton className="h-3 w-full rounded-md" />
              </div>
            ))}
          </div>

          <Skeleton className="h-11 w-44 rounded-md" />
        </div>
      </section>
    </div>
  )
}
